import { createFileRoute } from '@tanstack/react-router';
import {
  NetworkCirclesSection,
  NetworkMembersSection,
  NetworkOverviewSection,
} from '@/components/networks/admin/index';
import { GroupVisibilitySection } from '@/components/group/admin/GroupVisibilitySection';
import { GroupArchiveSection } from '@/components/group/admin/GroupArchiveSection';
import { GroupRequestsSection } from '@/components/group/admin/GroupRequestsSection';
import { GroupBroadcastsSection } from '@/components/group/admin/GroupBroadcastsSection';
import { createGroupAdminRoute } from '@/lib/route-factories/group-admin-route';

export const Route = createFileRoute('/_authed/networks/$id/admin/')(
  createGroupAdminRoute({
    kind: 'network',
    fromId: '/_authed/networks/$id/admin/',
    renderSection: ({ id, section, broadcastStatus, broadcastCursor, session }) => {
      switch (section) {
        case 'overview':
          return <NetworkOverviewSection networkId={id} />;
        case 'visibility':
          return <GroupVisibilitySection id={id} kind="network" />;
        case 'requests':
          return <GroupRequestsSection kind="network" groupId={id} />;
        case 'members':
          return (
            <NetworkMembersSection
              networkId={id}
              viewerUserId={session.userId as string}
            />
          );
        case 'circles':
          return <NetworkCirclesSection networkId={id} />;
        case 'broadcasts':
          return (
            <GroupBroadcastsSection
              kind="network"
              groupId={id}
              listStatus={broadcastStatus}
              listCursor={broadcastCursor}
            />
          );
        case 'archive':
          return <GroupArchiveSection groupId={id} kind="network" />;
      }
    },
  }),
);
